import './TemplateReport.less';
import React from 'react';
import DefaultReport from './DefaultReport';
import TemplateHeader from './TemplateHeader';
import { REPORT_RENDER_ENGINE_URL } from '../../settings/config';
import { Divider } from 'antd';
import TemplateFooter from './TemplateFooter';
import { useSelector } from 'react-redux';
import { getLoggedInUserGuid } from '../../store/iam/selectors';

type Props = {
    templateGuid: string;
    reportUrl?: string;
    reportGuid?: string;
    logo?: string;
    header?: string;
    footer?: string;
};

export default function TemplateReport({ templateGuid, reportUrl, reportGuid, logo, header, footer }: Props) {
    const userGuid = useSelector((state) => getLoggedInUserGuid(state));

    return (
        <div className="custom-pdf">
            <TemplateHeader
                logo={logo}
                header={header}
            />

            {!reportUrl && <DefaultReport />}

            {reportUrl && (
                <div className="iframe-wrapper">
                    <iframe
                        id="test"
                        height="450px"
                        width="605px"
                        frameBorder="0"
                        title="unique-title-to-be-added"
                        src={`${REPORT_RENDER_ENGINE_URL}?report_guid=${
                            reportGuid || 'latest'
                        }&report_url=${reportUrl}&template_guid=${templateGuid}&user_guid=${userGuid}&output_type=pdf`}
                    ></iframe>
                </div>
            )}

            <Divider />

            <TemplateFooter footer={footer} />
        </div>
    );
}
